/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInvitationRequest
 */
export interface CreateInvitationRequest {
    /**
     * Email address of the person to invite
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    email: string;
    /**
     * Role to assign to the invited user
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    role: CreateInvitationRequestRoleEnum;
    /**
     * First name of the person to invite
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    firstName?: string;
    /**
     * Last name of the person to invite
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    lastName?: string;
}


/**
 * @export
 */
export const CreateInvitationRequestRoleEnum = {
    Admin: 'admin',
    User: 'user'
} as const;
export type CreateInvitationRequestRoleEnum = typeof CreateInvitationRequestRoleEnum[keyof typeof CreateInvitationRequestRoleEnum];


/**
 * Check if a given object implements the CreateInvitationRequest interface.
 */
export function instanceOfCreateInvitationRequest(value: object): value is CreateInvitationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function CreateInvitationRequestFromJSON(json: any): CreateInvitationRequest {
    return CreateInvitationRequestFromJSONTyped(json, false);
}

export function CreateInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'role': json['role'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}

export function CreateInvitationRequestToJSON(json: any): CreateInvitationRequest {
    return CreateInvitationRequestToJSONTyped(json, false);
}

export function CreateInvitationRequestToJSONTyped(value?: CreateInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'role': value['role'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

